/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { resetFunctionwithlogin } from "../../../components/ResetFunction";
import { useSelector } from "react-redux";
import { useLoginMutation } from "../../../services/auth.service";
// import { login } from "../../../user";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(20, "Password must be at most 20 characters")
    .required("Password is required"),
});

const Login = () => {
  const {isAuthenticated, user} = useSelector(state => state.user);
  const [login, { isLoading }] = useLoginMutation();

  console.log(user)
  useEffect(() => {
    if (isAuthenticated )
      navigate("/dashboard")
  }, [isAuthenticated]);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const navigate = useNavigate();

  const onSubmit = (data) => {
    // const payload = {
    //   email: data.email.toLowerCase(),
    //   password: data.password
    // }
    login(data)
    // .then(res => {
    //   if (res.success) {
    //     localStorage.setItem("colorschema", "orange");
    //     localStorage.setItem("layout", "horizontal");
    //     localStorage.setItem("layoutwidth", "fixed");
    //     localStorage.setItem("layoutpos", "fluid");
    //     localStorage.setItem("topbartheme", "light");
    //     localStorage.setItem("layoutSized", "lg");
    //     localStorage.setItem("layoutStyling", "default");
    //     localStorage.setItem("layoutSidebarStyle", "dark");
    //   }
    // })
    // const currentUser = loginData?.find((item) => item?.email === data?.email);
    // if (!currentUser) {
    //   setEmailError(true); // Email is not registered
    //   navigate("/");
    // } else if (currentUser.password === data?.password) {
    //   localStorage.setItem("colorschema", "orange");
    //   localStorage.setItem("layout", "vertical");
    //   localStorage.setItem("layoutwidth", "fixed");
    //   localStorage.setItem("layoutpos", "fluid");
    //   localStorage.setItem("topbartheme", "light");
    //   localStorage.setItem("layoutSized", "lg");
    //   localStorage.setItem("layoutStyling", "default");
    //   localStorage.setItem("layoutSidebarStyle", "dark");

    //   setEmailError(false); // Email is registered, and password is correct
    //   const Value = {
    //     email: data?.email,
    //     password: data?.password,
    //   };
    //   dispatch(login(Value));
    //   localStorage.setItem("credencial", JSON.stringify(Value));
    //   navigate("/dashboard");
    //   resetFunctionwithlogin();
    // } else {
    //   setEmailError(true); // Email is registered, but the password is incorrect
    //   navigate("/");
    // }
  };

  const [eye, seteye] = useState(true);

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/dashboard">
                  <img src={Applogo} alt="Dreamguy's Technologies" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Login</h3>
                  <p className="account-subtitle">Access to our dashboard</p>
                  {/* Account Form */}
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-block mb-4">
                        <label className="col-form-label">Email Address</label>
                        <Controller
                          name="email"
                          control={control}
                          render={({ field }) => (
                            <input
                              className={`form-control ${
                                errors?.email ? "error-input" : ""
                              }`}
                              type="text"
                              autoCapitalize={false}
                              onChange={field.onChange}
                              value={field.value}
                              autoComplete="true"
                            />
                          )}
                        />

                        <span className="text-danger">
                          {" "}
                          {errors.email?.message}{" "}
                        </span>
                      </div>
                      <div className="input-block mb-4">
                        <div className="row">
                          <div className="col">
                            <label className="col-form-label">Password</label>
                          </div>
                          <div className="col-auto">
                            <Link className="text-muted" to="/forgot-password">
                              Forgot password?
                            </Link>
                          </div>
                        </div>
                        <div style={{ position: "relative" }}>
                          <Controller
                            name="password"
                            control={control}
                            render={({ field }) => (
                              <input
                                className={`form-control ${
                                  errors?.password ? "error-input" : ""
                                }`}
                                type={eye ? "password" : "text"}
                                value={field.value}
                                onChange={field.onChange}
                                // autoComplete="true"
                              />
                            )}
                          />
                          <span
                            style={{
                              position: "absolute",
                              right: "5%",
                              top: "30%",
                            }}
                            onClick={onEyeClick}
                            className={`fa-solid ${
                              eye ? "fa-eye-slash" : "fa-eye"
                            } `}
                          />
                        </div>
                        <span className="text-danger">
                          {" "}
                          {errors.password?.message}{" "}
                        </span>
                      </div>
                      <div className="input-block text-center">
                        <button
                          className="btn btn-primary account-btn"
                          type="submit"
                        >
                          Login
                        </button>
                      </div>
                    </form>
                    <div className="account-footer">
                      <p>
                        Don't have an account yet?{" "}
                        <Link to="/register">Register</Link>
                      </p>
                      <p className="mt-2">
                        Need help?{" "}
                        <Link to="/contact-admin">Contact Admin</Link>
                      </p>
                      <p className="mt-2">
                        <Link to="/privacy-policy" className="text-muted">Privacy Policy</Link>
                        {" | "}
                        <Link to="/terms-and-conditions" className="text-muted">Terms & Conditions</Link>
                      </p>
                    </div>
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
